module.exports = __webpack_public_path__ + "static/img/landmark-product-top.f587624.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landmark-product-top.jpg
// module id = 1400
// module chunks = 1